import React from 'react'
import { Container, FilledButton } from '@jsluna/react'
import { PropTypes } from 'prop-types'
import ContractorGrid from 'components/ContractorGrid'
import { withRouter } from 'react-router-dom'
import { VisibilityFilters } from 'actions'
import api from '../../utils/api'

class ManageContractors extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      employerId: this.props.employerId,
      contractors: [],
      allContractors: [],
      hasContractors: false,
      hasInactiveContractors: false,
      hasErrorLoadingContractors: this.props.hasErrorLoadingContractors
    }
    this.handleSelect = this.handleSelect.bind(this)
    this.handleActiveFilter = this.handleActiveFilter.bind(this)
    this.handleAddContractor = this.handleAddContractor.bind(this)
  }

  componentWillMount() {
    this.getData(this.props.showActiveOnly)
  }

  getData(showActiveOnly) {
    if (this.state.employerId > 0 && this.props.contractors !== null) {
      this.setState({
        allContractors: this.props.contractors,
        contractors: showActiveOnly ? this.props.contractors.filter((contractor) => contractor.active === true) : this.props.contractors,
        hasContractors: Object.keys(this.props.contractors).length > 0,
        hasInactiveContractors: this.props.contractors.filter((contractor) => contractor.active === false).length > 0
      })
    } else {
      this.setState({ allContractors: [], contractor: [] })
    }
  }

  getFilteredContractors(showActiveOnly) {
    if(showActiveOnly) {
      this.setState({
        contractors: this.state.allContractors.filter((contractor) => contractor.active === true )
      })
    }
    else {
      this.setState({
        contractors: this.state.allContractors
      })
    }
  }

  handleSelect(contractor) {
    this.props.history.push(`/employers/${this.props.employerId}/contractors/${contractor.id}`)
  }

  handleActiveFilter() {
    // Invert the visibility filter based on the original showActiveOnly setting.
    const showActiveOnly = !this.props.showActiveOnly

    this.props.setContractorActiveFilter({
      employerId: this.props.employerId,
      filter: showActiveOnly ? VisibilityFilters.SHOW_ACTIVE : VisibilityFilters.SHOW_ALL
    })

    this.getFilteredContractors(showActiveOnly)
  }

  handleAddContractor() {
    this.props.history.push(`/employers/${this.props.employerId}/contractors/add`)
  }

  render() {
    return (
      <div className="ln-c-main-content" id="main-content">
        { this.state.hasErrorLoadingContractors === true &&
        <Container soft className="ln-u-text-align-center">
          <div className="ln-o-grid ln-u-soft-top">
            <div className="ln-o-grid__item ln-u-1/3">
              <div className="ln-c-form-group has-error">
                <p className="ln-c-field-info ln-c-field-info--error">
                  Error loading contractors
                </p>
              </div>
            </div>
          </div>
        </Container>
        }
        { this.state.hasErrorLoadingContractors === false &&
        <div>
          <Container
            soft
            className={this.state.hasContractors ?
              'ln-u-hidden' :
              'ln-u-soft'}
          >
            <div
              className="[ ln-o-grid ln-o-grid--center ] ln-u-text-align-center ln-u-1/2"
            >
              <div className="ln-o-grid__item ln-u-font-family-brand ln-u-font-size-h4 ln-u-font-weight-bold  ln-u-1/4">
                There are currently no colleagues
              </div>
              <div className="ln-o-grid__item ln-u-1/5">
                <FilledButton
                  id="cmdAddContractor"
                  className="ln-c-button ln-c-button--primary ln-u-1/1"
                  onClick={this.handleAddContractor}
                  disabled={this.props.isReadOnly}
                >Add a new colleague</FilledButton>
              </div>
            </div>
          </Container>
          <Container
            className={this.state.hasContractors ?
              'ln-u-soft-top ln-u-soft-left ln-u-soft-right' :
              'ln-u-hidden'}
          >
            <div className="ln-o-flag">
              <div className="ln-o-flag__body">
                <div className="ln-u-soft-right">
                  <FilledButton
                    id="cmdAddContractor"
                    className="ln-c-button ln-c-button--primary ln-u-1/4@md ln-u-1/2@sm"
                    onClick={this.handleAddContractor}
                    disabled={this.props.isReadOnly}
                  >Add new colleague</FilledButton>
                </div>
              </div>
              { this.state.hasInactiveContractors && 
                <div className="ln-o-flag__component ln-o-generic--flag-outer-padding-right-small">
                  <div className="ln-o-flag__component ln-o-generic--flag-inner-minimum-width ln-c-form-option ln-c-form-option--checkbox">
                    <input
                      className="ln-c-form-option__input"
                      id="chkShowInactive"
                      type="checkbox"
                      defaultChecked={!this.props.showActiveOnly}
                      onChange={this.handleActiveFilter}
                    />
                    <label className="ln-c-form-option__label" htmlFor="chkShowInactive">Show inactive colleagues</label>
                  </div>
                </div>              
              }
            </div>
            <Container
              className={(this.state.contractors.length > 0) ?
                'ln-u-soft-bottom' :
                'ln-u-hidden'}
            >
              <ContractorGrid
                employerId={this.props.employerId}
                contractors={this.state.contractors}
                onSelect={this.handleSelect}
                isReadOnly={this.props.isReadOnly}
              />
            </Container>
            <Container soft className={(this.state.contractors.length > 0) ? 'ln-u-hidden' : 'ln-u-soft'}>
              <div className="[ ln-o-grid ln-o-grid--center ]">
                <div className={'ln-o-grid__item ln-u-text-align-center ln-u-font-family-brand ln-u-font-size-h4 ln-u-font-weight-bold'}>
                  There are currently no active colleagues
                </div>
              </div>
            </Container>
          </Container>
        </div>
        }
      </div>
    )
  }
}

ManageContractors.propTypes = {
  employerId: PropTypes.number.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  showActiveOnly: PropTypes.bool.isRequired,
  setContractorActiveFilter: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  contractors: PropTypes.array.isRequired,
  hasErrorLoadingContractors: PropTypes.bool.isRequired
}

export default withRouter(ManageContractors)



// WEBPACK FOOTER //
// ./src/components/ManageContractors/ManageContractors.jsx